"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNavButton = exports.StyledNavItem = exports.StyledNavListItem = exports.StyledNavList = exports.StyledCloseButton = exports.StyledCloseButtonWrapper = exports.StyledHamburgerLine = exports.StyledHamburger = exports.StyledHamburgerWrapper = exports.StyledNav = exports.StyledLogoLink = exports.StyledHeader = void 0;
const react_router_dom_1 = require("react-router-dom");
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHeader = styled_components_1.default.header.withConfig({ displayName: "StyledHeader", componentId: "sc-1cuuy3g" }) `
  ${ui_1.backgroundGradient}

  ${(props) => (0, ui_1.mq)({
    padding: [`${props.theme.spacers.x3} 0`, null, `${props.theme.spacers.x6} 0`],
})}
`;
exports.StyledLogoLink = (0, styled_components_1.default)(react_router_dom_1.Link).withConfig({ displayName: "StyledLogoLink", componentId: "sc-13mw5tf" }) `
  display: flex;
`;
exports.StyledNav = styled_components_1.default.nav.withConfig({ displayName: "StyledNav", componentId: "sc-1cp0j3d" }) `
  top: 0;
  right: 0;
  transition: opacity 250ms;

  ${(props) => (0, ui_1.mq)({
    background: [(0, ui_1.hexToRgba)(props.theme.colors.darkEclipse, 0.95), null, 'transparent'],
    position: ['fixed', null, 'static'],
    width: ['50%', null, 'auto'],
    height: ['100%', null, 'auto'],
    opacity: [props.isOpen ? 1 : 0, null, 1],
    zIndex: [props.isOpen ? 2 : -1, null, 1],
})}
`;
exports.StyledHamburgerWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledHamburgerWrapper", componentId: "sc-16y02af" }) `
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  ${(0, ui_1.mq)({
    display: ['flex', null, 'none'],
})}
`;
exports.StyledHamburger = (0, styled_components_1.default)(ui_1.Clickable).withConfig({ displayName: "StyledHamburger", componentId: "sc-3f5wtt" }) `
  width: 22px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
exports.StyledHamburgerLine = styled_components_1.default.span.withConfig({ displayName: "StyledHamburgerLine", componentId: "sc-1yme4qr" }) `
  width: 100%;
  height: 2px;
  background: ${(props) => props.theme.colors.white};
`;
exports.StyledCloseButtonWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledCloseButtonWrapper", componentId: "sc-17u4t9k" }) `
  justify-content: flex-end;
  align-items: center;
  height: 18px;
  z-index: 3;
  position: fixed;

  ${(0, ui_1.mq)({
    display: ['flex', null, 'none'],
})}
`;
exports.StyledCloseButton = (0, styled_components_1.default)(ui_1.Clickable).withConfig({ displayName: "StyledCloseButton", componentId: "sc-nuv51q" }) `
  width: 18px;
  height: 18px;
  position: relative;

  &:before,
  &:after {
    position: absolute;
    left: 8px;
    content: ' ';
    height: 22px;
    width: 2px;
    background: ${(props) => props.theme.colors.white};
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;
exports.StyledNavList = styled_components_1.default.ul.withConfig({ displayName: "StyledNavList", componentId: "sc-1w2cjoh" }) `
  display: flex;
  justify-content: flex-end;
  gap: ${(props) => props.theme.spacers.x3};
  padding: 0;
  margin: 0;
  list-style: none;

  ${(props) => (0, ui_1.mq)({
    flexDirection: ['column', null, 'row'],
    paddingTop: [props.theme.spacers.x9, null, 0],
    paddingLeft: [props.theme.spacers.x5, null, 0],
})}
`;
exports.StyledNavListItem = styled_components_1.default.li.withConfig({ displayName: "StyledNavListItem", componentId: "sc-1jxi14q" }) ``;
exports.StyledNavItem = styled_components_1.default.a.withConfig({ displayName: "StyledNavItem", componentId: "sc-1oah10m" }) `
  ${(props) => props.theme.responsiveFontsize.body.medium}
  font-weight: ${(props) => props.theme.fontWeights.medium};
  text-decoration: ${(props) => (props.isActive ? 'underline' : 'none')};
  text-underline-offset: 10px;
  color: ${(props) => props.theme.colors.white};

  &:hover {
    text-decoration: underline;
  }
`;
exports.StyledNavButton = styled_components_1.default.a.withConfig({ displayName: "StyledNavButton", componentId: "sc-181ym26" }) `
  ${(props) => props.theme.responsiveFontsize.body.medium}
  font-weight: ${(props) => props.theme.fontWeights.medium};
  text-decoration: none;
  color: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacers.x1} ${(props) => props.theme.spacers.x2};
  border-radius: ${(props) => props.theme.radii.primary};
  border: 1px solid ${(props) => props.theme.colors.white};

  &:hover {
    background: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.celticBlue};
  }

  ${() => (0, ui_1.mq)({
    display: ['inline-block', null, 'inline'],
})}
`;
